import React, { memo } from "react";
import {
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import CheckAndReturn from "../../utility/CheckAndReturn";
import LoaderNew from "../Loader/LoaderNew";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
//FUNCTION
const ItemLedgerCard = ({ itemLedger, selectedItem, itemLedgerLoading }) => {
  const QuantityWithArrow = ({ type, quantity }) => {
    const redTypes = ["Invoice", "Challan", "Purchase"];
    const greenTypes = ["Credit Note"]; // Stock Update yaha nahi rakhenge

    const isRed = redTypes.includes(type);
    const isGreen = greenTypes.includes(type);

    // 🔥 Special Logic for Stock Update
    if (type === "Stock Update") {
      const isNegative = Number(quantity) < 0;

      return (
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          sx={{ color: isNegative ? "red" : "green" }}
        >
          {isNegative ? (
            <ArrowDownwardIcon fontSize="small" />
          ) : (
            <ArrowUpwardIcon fontSize="small" />
          )}
          <Typography variant="body2">{Math.abs(quantity)}</Typography>
        </Stack>
      );
    }

    // 👉 Agar koi aur type hai aur red/green list me nahi hai
    if (!isRed && !isGreen) {
      return <Typography variant="body2">{quantity}</Typography>;
    }

    return (
      <Stack
        direction="row"
        spacing={0.5}
        alignItems="center"
        sx={{ color: isRed ? "red" : "green" }}
      >
        {isRed ? (
          <ArrowDownwardIcon fontSize="small" />
        ) : (
          <ArrowUpwardIcon fontSize="small" />
        )}
        <Typography variant="body2">{quantity}</Typography>
      </Stack>
    );
  };
  return (
    <>
      <Grid container alignItems={"center"} spacing={2} mb={1}>
        <Grid
          container
          item
          xs={12}
          md={12}
          justifyContent={{ xs: "center", md: "center" }}
        >
          <Box flex={1} textAlign="center">
            <Typography variant="h5" color="#1e61b4" fontWeight={700}>
              {itemLedgerLoading === true ? (
                <LoaderNew />
              ) : (
                selectedItem.item_name
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={12}
          justifyContent={{ xs: "center", md: "center" }}
        >
          <Stack direction={"row"}>
            <Typography variant="body1" fontWeight={600}>
              Opening Quantity:
            </Typography>
            <Typography variant="body1" ml={2}>
              {itemLedgerLoading === true ? (
                <LoaderNew />
              ) : (
                selectedItem.openingquantity
              )}
            </Typography>
          </Stack>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={12}
          justifyContent={{ xs: "center", md: "center" }}
        >
          <Stack direction={"row"}>
            <Typography variant="body1" fontWeight={600}>
              Actual Quantity:
            </Typography>
            <Typography variant="body1" ml={2}>
              {itemLedgerLoading === true ? (
                <LoaderNew />
              ) : (
                selectedItem.actualquantity
              )}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      {itemLedger.length > 0 ? (
        itemLedger.map((item, index) => (
          <Card
            sx={{
              marginBottom: "16px",
              padding: "16px",
              backgroundColor: "#f9f9ff",
            }}
            key={index}
          >
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Type:
                    </Typography>
                    <Typography variant="body1">{item.type}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Name:
                    </Typography>
                    <Typography variant="body1">{item.name}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Inv No/Bill No:
                    </Typography>
                    <Typography variant="body1">
                      {item.entity_number}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Customer Name:
                    </Typography>
                    <Typography variant="body1">
                      {item.customer_name}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Location
                    </Typography>
                    <Typography variant="body1">
                      {item.location_name}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Quantity:
                    </Typography>
                    <Typography variant="body1">
                      <QuantityWithArrow
                        type={item.type}
                        quantity={item.quantity}
                      />
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Rate:
                    </Typography>
                    <Typography variant="body1">₹{item.rate}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Amount:
                    </Typography>
                    <Typography variant="body1">
                      ₹{CheckAndReturn.roundToInteger(item.amount)}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Typography variant="body1" color="textSecondary">
                      Date:
                    </Typography>
                    <Typography variant="body1">
                      {CheckAndReturn.transformToDate3(item.date)}
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ))
      ) : (
        <LoaderNew />
      )}
    </>
  );
};

export default memo(ItemLedgerCard);
